const axios = require("axios")

let url = 'https://axonics-locator.herokuapp.com';
// let url = 'https://doctor-locator-app.herokuapp.com';
// let url = process.env.REACT_APP_LIVE_URL
// let url = `http://localhost:8585`
export const loginApi = async ({ email, password }) => {
  let logindata = await axios.post(`${url}/admin/login`, {
    email,
    password
  })
  return logindata
}

export const userloginApi = async ({ email, password }) => {
  let logindata = await axios.post(`${url}/user/login`, {
    email,
    password
  })
  return logindata
}
export const usersignupApi = async (payload) => {
  let signupdata = await axios.post(`${url}/user/register`, payload)
  return signupdata
}

export const userDataUpdateApi = async (payload) => {
  let allData = await axios.post(`${url}/user/update-user`, payload)
  return allData
}

export const userforgotApi = async (payload) => {
  let forgotdata = await axios.post(`${url}/user/reset-password`, payload)
  return forgotdata
}

export const userUpdateApi = async (payload) => {
  let updatedata = await axios.post(`${url}/user/update-password/`, payload)
  return updatedata
}

export const getDoctor = async () => {
  let token = JSON.parse(localStorage.getItem("token"))
  let getData = await axios.get(`${url}/all-doctors`, { headers: { Authorization: token } })
  return getData
}

export const addDoctor = async (data
  // { email, practiceEmail, firstName, lastName, phone, centerName, websiteURL, Address, zip, latLong, saleRepresentative, saledirector, speciality, iTreatPatient, iTreat, otherSpeciality }
) => {
  let token = JSON.parse(localStorage.getItem("token"))
  let addData = await axios.post(`${url}/add-doctor`, data, { headers: { Authorization: token } })

  return addData
}

export const editDoctor = async ({ _id, email, practiceEmail, firstName, lastName, phone, centerName, websiteURL, Address, zip, latLong, saleRepresentative, saledirector, speciality, iTreatPatient, iTreat, otherSpeciality, centerOfExcellence = false, productTypes }) => {
  let token = JSON.parse(localStorage.getItem("token"))
  let editedData = await axios.post(`${url}/edit-doctor/${_id}`, {
    email, practiceEmail, firstName, lastName, phone, centerName, websiteURL, Address, zip, latLong, saleRepresentative, saledirector, speciality, iTreatPatient, iTreat, otherSpeciality, centerOfExcellence, productTypes
  }, { headers: { Authorization: token } })
  return editedData
}

export const deleteDoctor = async (row) => {
  let isDeleted = row.isDeleted
  let token = JSON.parse(localStorage.getItem("token"))
  let deletedData = await axios.post(`${url}/delete-doctor/${row._id}`, { isDeleted }, { headers: { Authorization: token } })
  return deletedData
}

export const getDoctorLocation = async ({ longitude, miles, latitude, zipcode, productTypes }) => {
  let getData = await axios.post(`${url}/all-doctors-range`, { longitude, miles, latitude, zipcode, productTypes })
  return getData
}

export const getUsersSmartSheetData = async () => {
  let token = JSON.parse(localStorage.getItem("token"))
  let getData = await axios.get(`${url}/user/user-smartsheet-data`, { headers: { Authorization: token } })
  return getData
}
export const getDoctorsSmartSheetData = async () => {
  let token = JSON.parse(localStorage.getItem("token"))
  let getData = await axios.get(`${url}/get-smartsheet-data`, { headers: { Authorization: token } })
  return getData
}



// WEBPACK FOOTER //
// ./src/doctorapi.js